// import { AccountantList } from 'components/Accountant';
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { AccountantList } from "../../../components/Accountant/AccountantList/AccountantList";

export interface IAccountantListPage {}

export const AccountantListPage: FC<IAccountantListPage> = (
	props: IAccountantListPage
) => {
	return (
		<AuthenticatedLayout
			pageTitle="Accountant List"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName="/AccountantDashboard"
			breadcrumbLinks={[]}
			mainContents={<AccountantList />}
		/>
	);
};
